import { getAuthHeaders } from '../../utils/token';
import { api } from '../Users/user';

const BASE_URL = api + '/api/branches';

/** Interfaz para la Sucursal devuelta por la API (incluye datos de la organización padre poblados) */
export interface BranchAPI {
  _id: string;
  fk_organization: {
    _id: string;
    name: string;
    short_name: string;
    oid: string;
  }; // Organización padre poblada
  name: string;
  short_name: string;
  oid: string;
  country_code: string;
  structure_id: string;
  suffix: string;
  base64_logo?: string;
  createdAt: string;
  updatedAt: string;
}

/** Interfaz para los datos necesarios para crear/actualizar una sucursal */
export interface BranchData {
  fk_organization: string; // Solo se envía el ID de MongoDB de la organización
  name: string;
  short_name: string;
  oid: string;
  country_code: string;
  structure_id: string;
  suffix: string;
  base64_logo?: string;
}

// --- Función de Utilidad para Fetch con Manejo de Errores (Reutilizada) ---
async function apiFetch<T>(url: string, options: RequestInit): Promise<T> {
  const defaultHeaders = getAuthHeaders();
  options.headers = {
    ...defaultHeaders,
    'Content-Type': 'application/json',
    ...options.headers,
  };

  const response = await fetch(url, options);

  const data = await response
    .json()
    .catch(() => ({ message: response.statusText || 'Error desconocido' }));

  if (!response.ok) {
    throw new Error(data.message || `La petición falló con status ${response.status}`);
  }

  return data as T;
}

/**
 * Obtiene la lista de todas las sucursales.
 */
export function fetchAllBranches(): Promise<BranchAPI[]> {
  return apiFetch<BranchAPI[]>(BASE_URL, {
    method: 'GET',
  });
}

/**
 * Obtiene sucursales filtradas por ID de Organización.
 */
export function fetchBranchesByOrganizationId(organizationId: string): Promise<BranchAPI[]> {
  return apiFetch<BranchAPI[]>(`${BASE_URL}/organization/${organizationId}`, {
    method: 'GET',
  });
}

/**
 * Crea una nueva sucursal.
 */
export function createBranch(branchData: BranchData): Promise<BranchAPI> {
  return apiFetch<BranchAPI>(BASE_URL, {
    method: 'POST',
    body: JSON.stringify(branchData),
  });
}

/**
 * Actualiza parcialmente una sucursal existente.
 */
export function updateBranch(
  id: string,
  branchData: Partial<BranchData>
): Promise<BranchAPI> {
  return apiFetch<BranchAPI>(`${BASE_URL}/${id}`, {
    method: 'PATCH',
    body: JSON.stringify(branchData),
  });
}

/**
 * Elimina una sucursal por su ID.
 */
export function deleteBranch(id: string): Promise<void> {
  return apiFetch<void>(`${BASE_URL}/${id}`, {
    method: 'DELETE',
  });
}
